import React from "react";
import PropTypes from "prop-types";
import TaskAssignee from "./TaskAssignee.jsx";

const TaskAssigneeContainer = ({ userId, shortName, linkName, className, children }) => {
  if (!userId && !children) return null;

  return (
    <TaskAssignee
      userId={userId}
      shortName={shortName}
      linkName={linkName}
      className={className}
    >
      {children}
    </TaskAssignee>
  );
};

TaskAssigneeContainer.propTypes = {
  userId: PropTypes.number,
  children: PropTypes.any,
  linkName: PropTypes.bool,
  className: PropTypes.string,
  shortName: PropTypes.bool,
};

TaskAssigneeContainer.defaultProps = {
  linkName: false,
  shortName: false,
};

TaskAssigneeContainer.displayName = `TaskAssigneeContainer`;

export default TaskAssigneeContainer;
